/**
 * Insurance quotes ...
 */

export const LINK_BUSINESS_INSURANCE_QUOTE = '/quotes/business-insurance-quote';
export const LINK_CAR_INSURANCE_QUOTE = '/quotes/car-insurance-quote';
export const LINK_VAN_INSURANCE_QUOTE = '/quotes/van-insurance-quote';
export const LINK_TAXI_INSURANCE_QUOTE = '/quotes/taxi-insurance-quote';
export const LINK_EMPLOYER_LIABILITY_INSURANCE_QUOTE = '/quotes/employer-liability-insurance-quote';
export const LINK_MOTOR_CYCLE_INSURANCE_QUOTE = '/quotes/motor-cycle-insurance-quote';
export const LINK_FAST_FOOD_DELIVERY_INSURANCE_QUOTE = '/quotes/fast-food-delivery-insurance-quote';
export const LINK_HOME_INSURANCE_QUOTE = '/quotes/home-insurance-quote';



/**
 * Claims ...
 */

export const LINK_ACCIDENT_MANAGEMENT_CLAIM = '/claims/accident-management-claim';

/**
 * Static pages ...
 */

export const LINK_TERMS = '/terms';
export const LINK_PRIVACY = '/privacy';
export const LINK_ABOUT_US = '/about';
export const LINK_CONTACT_US = '/contact';
export const LINK_HOME_CAR_DETAILS = '/car-details';

/**
 * Blog pages ...
 */

export const LINK_BLOG_POSTS = '/blog/posts';
export const LINK_BLOG_POST_DETAILS = '/blog/post/';
export const LINK_BLOG_AUTHOR_DETAILS = '/blog/author/';

/**
 * Agent pages ...
 */
export const LINK_AGENTS_LONDON = '/agents/cheapest-car-insurance-in-london';
export const LINK_AGENTS_BIRMINGHAM = '/agents/cheapest-insurance-in-birmingham';
export const LINK_AGENTS_OLDHAM = '/agents/cheapest-insurance-in-oldham';
export const LINK_AGENTS_LOUGHBORO = '/agents/cheapest-car-insurance-in-leicester-and-loughborough';
export const LINK_AGENTS_MANCHESTER = '/agents/cheapest-car-insurance-in-manchester';
export const LINK_AGENTS_BRADFORD = '/agents/cheapest-car-insurance-in-bradford';
export const LINK_AGENTS_NEWCASTLE = '/agents/cheapest-car-insurance-in-newcastle';
